import { render } from "./LogIns.vue?vue&type=template&id=24007fa8"
import script from "./LogIns.vue?vue&type=script&lang=js"
export * from "./LogIns.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__